<template>

    <div class="page_content module_course" v-if="permission && permission.version === '5'" aria-label="Enroll Page Content">

        <course-header :course-id="course.uuid" class="header_course_dashboard"></course-header>

        <div class="row page-content">

            

            <div class="col-11 enroll_user">

                  <b-row class="dashboard-row">

                    <b-col cols="4" v-if="!course.master">
                        <div class="card ace_sec" aria-label="Enroll Student Section">
                            <div class="card-header">
                                <span class="bx_hd_ic ico-student"></span>
                                <span class="label ace_sec_hd" role="heading" aria-level="1" tabindex="0">Students</span>
                            </div>
                            <div class="card-body">

	                            <div class="usr_count ace_sec_txt">
	                            	# of Students - {{students}}
	                            </div>
	                             <div class="btn_container">
	                            	 <b-button :to="{ name: 'enrollStudent', params: { uuid: course.uuid, title: course.title } }" variant="primary" class="btn" :disabled="(permission.systemPermission.readOnly || !permission.coursePermission.enrollStudent)" :style="{background: permission.systemPermission.readOnly ? '#ccc' : ''}" aria-label="enroll students">Enroll Students</b-button>
	                            </div>

                            </div>
                        </div>
                    </b-col>

                    <b-col cols="4">
                        <div class="card ace_sec" aria-label="Enroll Curators Section">
                            <div class="card-header">
                                <span class="bx_hd_ic ico-teacher"></span>
                                <span class="label ace_sec_hd" role="heading" aria-level="2" tabindex="0">Curators</span>
                            </div>
                            <div class="card-body">

	                            <div class="usr_count ace_sec_txt">
	                            	# of Curators - {{curators}}
	                            </div>
	                             <div class="btn_container">
	                            	<b-button :to="{ name: 'enrollCurator', params: { uuid: course.uuid, title: course.title } }" variant="primary" class="btn" :disabled="(permission.systemPermission.readOnly || !permission.coursePermission.enrollCurator)" :style="{background: permission.systemPermission.readOnly ? '#ccc' : ''}" aria-label="enroll curators">Enroll Curators</b-button>
	                            </div>

                            </div>
                        </div>
                    </b-col>

                    <b-col cols="4">
                        <div class="card ace_sec" aria-label="Enroll Instructors Section">
                            <div class="card-header">
                                <span class="bx_hd_ic ico-teacher"></span>
                                <span class="label ace_sec_hd" role="heading" aria-level="3" tabindex="0">Instructors</span>
                            </div>
                            <div class="card-body">

	                            <div class="usr_count ace_sec_txt">
	                            	# of Instructors - {{instructors}}
	                            </div>
	                             <div class="btn_container">
	                            	<b-button :to="{ name: 'enrollInstructor', params: { uuid: course.uuid, title: course.title } }" variant="primary" class="btn" :disabled="(permission.systemPermission.readOnly || !permission.coursePermission.enrollInstructor)" :style="{background: permission.systemPermission.readOnly ? '#ccc' : ''}" aria-label="enroll instructors">Enroll Instructors</b-button>
	                            </div>

                            </div>
                        </div>
                    </b-col>
                    
                    <b-col cols="4" v-if="!course.master">
                        <div class="card ace_sec" aria-label="Enroll Observers Section">
                            <div class="card-header">
                                <span class="bx_hd_ic ico-teacher"></span>
                                <span class="label ace_sec_hd" role="heading" aria-level="4" tabindex="0">Observers</span>
                            </div>
                            <div class="card-body">

                                <div class="usr_count ace_sec_txt">
                                    # of Observers - {{observers}}
                                </div>
                                 <div class="btn_container">
                                    <b-button :to="{ name: 'enrollObserver', params: { uuid: course.uuid, title: course.title } }" variant="primary" class="btn" :disabled="(permission.systemPermission.readOnly || !permission.coursePermission.enrollObserver)" :style="{background: permission.systemPermission.readOnly ? '#ccc' : ''}" aria-label="enroll observers">Enroll Observers</b-button>
                                </div>

                            </div>
                        </div>
                    </b-col>

                </b-row>

            </div>

        </div>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                </div>
            </b-modal>
        </div>

   </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import CourseNav from './CourseNav'
import CourseHeader from './CourseHeader'

export default {
  name: 'enrollmentPage',
  props: ['uuid'],
  components: {
    CourseNav,
    CourseHeader
  },
  data () {
    return {
      students: 0,
      curators: 0,
      observers: 0,
      instructors: 0
    }
  },
  mounted () {
    this.loadPermission().then(res => {
      this.$refs.loadingModal.show()
      this.loadCourse()
    })
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadEnrolledStudentUsers',
      'loadEnrolledCuratorUsers',
      'loadEnrolledInstructorUsers',
      'loadEnrolledObserverUsers',
      'loadPermission'
    ]),
    loadCourse () {
      this.loadCourseDetail(this.uuid).then(res => {
        this.loadEnrolledStudentUsers(this.uuid).then(res => {
          this.students = res.content.length
        })
        this.loadEnrolledCuratorUsers(this.uuid).then(res => {
          this.curators = res.content.length
        })
        this.loadEnrolledInstructorUsers(this.uuid).then(res => {
          this.instructors = res.content.length
        })
        this.loadEnrolledObserverUsers(this.uuid).then(res => {
          this.observers = res.content.length
        })
        setTimeout(() => {
          this.$refs.loadingModal.hide()
        }, 500)
      })
    }

  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'permission': state => state.user.permission
    })
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/course/components/Enroll.vue